import { getAuthClaims } from '../../utils/authToken';

// Same source of truth as the rest of the dashboard: the `role` claim of the
// stored JWT (see utils/authToken). The login service issues it lowercase
// ("admin"), so compare case-insensitively.
export const isAdminRole = (role) =>
  typeof role === 'string' && role.toLowerCase() === 'admin';

// UI-only convenience: this hides the cards/actions non-admin users don't need.
// The actual boundary is enforced server-side (webback @PreAuthorize on the
// ROP settings/media endpoints), so this is not the last line of defense.
//
// Deliberately not memoized: getAuthClaims().role reads localStorage, so the
// only way to keep the result fresh across a re-login/token refresh while the
// ROP tab stays mounted is to re-read it on every render — the check itself
// is cheap enough that this costs nothing worth caching.
export const useIsAdmin = () => isAdminRole(getAuthClaims().role);
